import React from 'react';
import { Polygon } from '@react-google-maps/api';
import { getZoneOptions } from 'helpers/utils';

const ViewZonePolygons = (props) => {
  const { zonesAllInfo, polygonRef, onPolygonClick, onLoad, onUnmount } = props;

  return zonesAllInfo
    .filter((zone) => zone.isActive === true)
    .map((zone, index) => {
      return (
        <Polygon
          key={index}
          ref={polygonRef}
          paths={zone.zonePolygonJson}
          options={getZoneOptions({
            editable: false,
            strokeOpacity: 0.8,
            fillColor: zone.color,
            fillOpacity: zone.transparency,
          })}
          onClick={(e) => onPolygonClick(e, zone)}
          onLoad={onLoad}
          onUnmount={onUnmount}
        />
      );
    });
};

export default ViewZonePolygons;
